<script setup lang="ts">
const { tournament } = defineProps<{ tournament: Tournament }>()

const { $ts: t } = useNuxtApp()

useSeoMeta({
  title: `${t('Results')} | ${tournament.name} @ ${tournament.event_name}`,
})

defineOgImageComponent('DartsSpace', {
  title: `${t('Results')} | ${tournament.name}`,
})
</script>

<template>
  <GamescreenTournamentResults :tournament-with-stats="tournament" />
</template>
